import React from 'react';

export default function RefundPolicyPage() {
  return (
    <div style={{ marginTop: 20 }}>
      <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 12 }}>Refund Policy</h2>
      <h3 style={{ fontSize: 16, fontWeight: 600, marginTop: 16 }}>Non-refundable after delivery begins</h3>
      <p style={{ fontSize: 14, lineHeight: '1.6' }}>Donations including Digital Content (private code) or private community access are non-refundable once delivery has begun (download or access issued).</p>
      <h3 style={{ fontSize: 16, fontWeight: 600, marginTop: 16 }}>EU</h3>
      <p style={{ fontSize: 14, lineHeight: '1.6' }}>Directive 2011/83/EU Art. 16(m) allows the exemption from withdrawal for digital content once performance begins with prior express consent and acknowledgment of withdrawal loss. You provide this consent at signature.</p>
      <h3 style={{ fontSize: 16, fontWeight: 600, marginTop: 16 }}>UK</h3>
      <p style={{ fontSize: 14, lineHeight: '1.6' }}>Consumer Contracts Regulations 2013 Reg. 37 similarly provide that cancellation rights are lost once delivery begins with consent and acknowledgment.</p>
      <h3 style={{ fontSize: 16, fontWeight: 600, marginTop: 16 }}>US & Canada</h3>
      <p style={{ fontSize: 14, lineHeight: '1.6' }}>Digital content and services are generally not refundable once accessed. We retain logs to evidence delivery and consent.</p>
      <h3 style={{ fontSize: 16, fontWeight: 600, marginTop: 16 }}>Before delivery begins</h3>
      <p style={{ fontSize: 14, lineHeight: '1.6' }}>If you have not accessed/downloaded any private code and no private community access has been issued, you may request a goodwill refund within 30 days of payment. Contact <strong>nelso@barbotine.xyz</strong> with your email and payment details.</p>
      
    </div>
  );
}


